// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__Pr7XE","form":"Register_form__JzVjo","form__submit":"Register_form__submit__dpnix","form__submit-inner":"Register_form__submit-inner__+enYX"};